import { useRef, useState } from "react";
import { API } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Play } from "lucide-react";

const VOICES = [
  { id: "female", label: "Feminina" },
  { id: "male", label: "Masculina" },
];
const SPEEDS = [
  { id: "slow", label: "Devagar" },
  { id: "normal", label: "Normal" },
  { id: "fast", label: "Rápida" },
];
export const LANGUAGES = [
  { id: "pt-BR", label: "Português (Brasil)" },
  { id: "es", label: "Espanhol" },
  { id: "en", label: "Inglês" },
  { id: "fr", label: "Francês" },
  { id: "it", label: "Italiano" },
  { id: "de", label: "Alemão" },
];

function Choice({ options, value, onChange, testid }) {
  return (
    <div className="inline-flex border border-border" data-testid={testid}>
      {options.map((o) => (
        <button key={o.id} type="button" onClick={() => onChange(o.id)} data-testid={`${testid}-${o.id}`}
          className={`px-4 py-2 text-sm font-medium transition-colors border-r border-border last:border-r-0 ${value === o.id ? "bg-ink text-cream" : "bg-white text-ink hover:bg-accent"}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

export const VoiceSettings = ({ clinicId, form, setForm }) => {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const preview = () => {
    if (audioRef.current) audioRef.current.pause();
    const a = new Audio(`${API}/tv/${clinicId}/test-audio?voice=${form.tts_voice}&speed=${form.tts_speed}&lang=${form.tts_language}`);
    audioRef.current = a;
    setPlaying(true);
    a.onended = () => setPlaying(false);
    a.onerror = () => setPlaying(false);
    a.play().catch(() => setPlaying(false));
  };
  return (
    <div className="space-y-3 border-t border-border pt-4" data-testid="voice-settings">
      <div>
        <Label className="mb-0">Voz da chamada</Label>
        <p className="text-xs text-cappuccino">Vale para todas as TVs da clínica depois de salvar.</p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Select value={form.tts_language} onValueChange={(v) => setForm({ ...form, tts_language: v })}>
          <SelectTrigger className="w-52 rounded-none h-10" data-testid="setting-language">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {LANGUAGES.map((l) => (
              <SelectItem key={l.id} value={l.id} data-testid={`setting-language-${l.id}`}>{l.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Choice options={VOICES} value={form.tts_voice} onChange={(v) => setForm({ ...form, tts_voice: v })} testid="setting-voice" />
        <Choice options={SPEEDS} value={form.tts_speed} onChange={(v) => setForm({ ...form, tts_speed: v })} testid="setting-speed" />
        <button type="button" onClick={preview} data-testid="voice-preview-button"
          className="inline-flex items-center gap-2 border border-gold text-ink px-4 py-2 text-sm font-medium hover:bg-accent transition-colors">
          {playing ? <Loader2 className="w-4 h-4 animate-spin" /> : <Play className="w-4 h-4 text-gold" />} Ouvir exemplo
        </button>
      </div>
    </div>
  );
};
